import { render, staticRenderFns } from "./PPortfolio.vue?vue&type=template&id=7633f25a&scoped=true&"
import script from "./PPortfolio.vue?vue&type=script&lang=ts&"
export * from "./PPortfolio.vue?vue&type=script&lang=ts&"
import style0 from "./PPortfolio.vue?vue&type=style&index=0&id=7633f25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633f25a",
  null
  
)

export default component.exports